<template>
    <div class="view">
        <!-- Header -->
        <div class="page-top text-center text-md-left">
            <div class="container h-100">
                <div class="row h-100 d-flex align-items-center">
                    <div class="col-md-5 mt-5 pt-5 mt-md-0">
                        <h2 class="h1-responsive mb-4">{{ msg.header.title }}</h2>
                    </div>
                    <div class="col-md-7">
                        <div class="pill-1 pink darken-1"></div>
                        <img src="../assets/svg/workspace-1.svg" class="w-100 p-5" alt="Image">
                    </div>
                </div>
            </div>
        </div>

        <hr class="container d-none d-md-block">

        <!-- About -->
        <div style="z-index: 1 !important; background-color: white;">
            <div class="container my-5 py-5">
                <div class="row d-flex align-items-center justify-content-between">
                    <div class="col-md-5">
                        <img src="../assets/svg/workspace-5.svg" class="w-75 mb-4 mb-md-0 mx-auto mx-md-0" alt="Image">
                    </div>
                    <div class="col-md-6 text-center text-md-left">
                        <h2 class="h2-responsive mb-4">{{ msg.about.title }}</h2>
                        <p>{{ msg.about.text }}</p>
                    </div>
                </div>
            </div>

            <div style="background-color: #f7f9fb; z-index: -100;" class="border-top border-bottom">
                <!-- Services -->
                <div class="container my-5 py-5 text-center">
                    <h2 class="h2-responsive mb-5">{{ msg.services.title }}</h2>
                    <div class="row d-flex align-items-center justify-content-between">
                        <div class="col-md-4 mb-4 mb-md-0">
                            <div class="card border">
                                <div class="card-body text-center py-5">
                                    <i class="fas fa-code fa-3x yellow-text"></i>
                                    <h3 class="h3-responsive my-3">{{ msg.services.website.title }}</h3>
                                    <router-link class="btn btn-yellow btn-rounded" to="/websites">{{ msg.services.button }}</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-4 mb-md-0">
                            <div class="card border">
                                <div class="card-body text-center py-5">
                                    <i class="fas fa-mobile-alt fa-3x light-green-text"></i>
                                    <h3 class="h3-responsive font-weight-normal my-3">{{ msg.services.mobileapps.title }}</h3>
                                    <router-link class="btn btn-light-green btn-rounded" to="/mobileapps">{{ msg.services.button }}</router-link>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 b-4 mb-md-0">
                            <div class="card border">
                                <div class="card-body text-center py-5">
                                    <i class="fas fa-server fa-3x orange-text"></i>
                                    <h3 class="h3-responsive my-3">{{ msg.services.maintenance.title }}</h3>
                                    <router-link class="btn btn-orange btn-rounded" to="/maintenance">{{ msg.services.button }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="container">

                <!-- How it works -->
                <div class="container my-5 py-5 text-center">
                    <div class="pill-2 d-none d-xl-block"></div>
                    <div class="pill-3 d-none d-xl-block"></div>
                    <div class="pill-4 d-none d-xl-block"></div>
                    <h2 class="h2-responsive mb-5">{{ msg.steps.title }}</h2>
                    <div class="row d-flex justify-content-center text-left">
                        <div class="col-md-10 text-center text-md-left">
                            <div class="row d-flex align-items-center justify-content-between my-5 py-2">
                                <div class="col-md-5">
                                    <h2 class="h1-responsive">01</h2>
                                    <h4 class="h4-responsive">{{ msg.steps.step1.title }}</h4>
                                    <p>{{ msg.steps.step1.text }}</p>
                                </div>
                                <div class="col-md-6">
                                    <img src="../assets/svg/workspace-3.svg" style="width: 85%" alt="Image" class="mx-auto mx-md-0">
                                </div>
                            </div>
                            <div class="row d-flex align-items-center justify-content-between my-5 py-2">
                                <div class="col-md-6">
                                    <img src="../assets/svg/workspace-4.svg" class="w-75 mb-4 mb-md-0 mx-auto mx-md-0" alt="Image">
                                </div>
                                <div class="col-md-5">
                                    <h2 class="h1-responsive">02</h2>
                                    <h4 class="h4-responsive">{{ msg.steps.step2.title }}</h4>
                                    <p>{{ msg.steps.step2.text }}</p>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center justify-content-between my-5 py-2">
                                <div class="col-md-5">
                                    <h2 class="h1-responsive">03</h2>
                                    <h4 class="h4-responsive">{{ msg.steps.step3.title }}</h4>
                                    <p>{{ msg.steps.step3.text }}</p>
                                </div>
                                <div class="col-md-6">
                                    <img src="../assets/svg/workspace-2.svg" class="w-75 mx-auto mx-md-0" alt="Image">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Technologies -->
            <div class="container my-5 py-5 text-center">
                <h2 class="h2-responsive mb-5">{{ msg.technologies.title }}</h2>
                <div class="row d-flex justify-content-center align-items-center">
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/html.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/css.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/bootstrap.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/vuejs.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/laravel.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/firebase.png" class="w-100" alt="Icon">
                    </div>
                    <div class="col-6 col-md-3 mb-4">
                        <img src="../assets/icons/mariadb.png" class="w-100" alt="Icon">
                    </div>
                </div>
            </div>
        </div>

        <hr class="container">

        <!-- Contact -->
        <contact />

    </div>
</template>

<script>
    import { lang } from './../language';
    import contact from './../components/Contact';
    export default {
        name: 'Home',
        components: { contact },
        data() {
            return {
                msg: null,
            }
        },
        created() {
            this.msg = lang.home_page;
        },
    }
</script>

<style scoped>
    .page-top {
        height: 75vh;
    }

    .pill-1 {
        content: "";
        position: absolute;
        height: 760px;
        width: 1450px;
        border-radius: 780px;
        z-index: 0;
        -webkit-transform: rotate(-60deg);
        transform: rotate(-60deg);
        right: -800px;
        top: -620px;
    }

    .pill-2 {
         content: "";
         position: absolute;
         height: 500px;
         width: 1300px;
         background-color: #ff9800;
         border-radius: 780px;
         z-index: 0;
         -webkit-transform: rotate(20deg);
         transform: rotate(20deg);
         left: -950px;
         top: 1350px;
     }

    .pill-3 {
        content: "";
        position: absolute;
        height: 500px;
        width: 1300px;
        background-color: #7cb342;
        border-radius: 780px;
        z-index: 0;
        -webkit-transform: rotate(25deg);
        transform: rotate(25deg);
        right: -950px;
        top: 2200px;
    }

    .pill-4 {
        content: "";
        position: absolute;
        height: 500px;
        width: 1300px;
        background-color: #ffeb3b;
        border-radius: 780px;
        z-index: 0;
        -webkit-transform: rotate(-25deg);
        transform: rotate(-25deg);
        left: -950px;
        top: 2600px;
    }

</style>
